export const BELT_COLORS = {
  white: '#FFFFFF',
  blue: '#416FF0',
  purple: '#9852DB',
  brown: '#864022',
  black: '#000000'
} as const;

export type BeltColor = keyof typeof BELT_COLORS;

export const getBeltColor = (color: BeltColor): string => {
  return BELT_COLORS[color];
};

// Interface for Tailwind CSS classes used in UI components
export interface BeltColorConfig {
  base: string;
  filled: string;
  opacity: string;
}
